import { SurveyConfirmDialog } from './SurveyConfirmDialog';

export type ArchiveSurveyConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  surveyName: string;
};

export const ArchiveSurveyConfirmDialog = ({
  onClose,
  onConfirm,
  loading,
  surveyName,
}: ArchiveSurveyConfirmDialogProps) => {
  return (
    <SurveyConfirmDialog
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      title='Archive General Survey'
      confirmButtonText='Archive'
      confirmButtonColor='error'
      description={`Are you sure you would like to archive "${surveyName}" from your program?`}
    />
  );
};
